import { gql } from 'apollo-angular';
import { PaymentMethod } from '../../shared/entities/paymentMethod/tenantLicenceRequest';

export const PAYMENT_METHOD_QUERY = gql`
query getPaymentMethod(
  $tenantId: String
)
{
  paymentMethod: getPaymentMethod(tenantId: $tenantId){
    type
    details
    updateLink
  }
}
`;

export interface PaymentMethodQueryResponse {
  loading: boolean;
  paymentMethod: PaymentMethod;
}

